import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {grayscale} from '/theme/color/on.color';
import {codGray} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  biometricContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginRight: indent,
  },
  biometricLabel: {
    marginLeft: indent - 5,
    color: codGray,
    fontWeight: 'bold',
  },
  itemIcon: {
    fontSize: 30,
    color: grayscale,
  },
  pinContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  biometricAndPinContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: indent,
  },
});
